const BLOB_PROPERTY_BAG_TYPE = 'text/csv;charset=utf-8;';
const CSV_EXTENSION = '.csv';

async function convertToCSV(data: object[]) {
    const { json2csv } = await import('json-2-csv');
    return json2csv(data);
}

export function useGenerateDownloadableCSV(reportFileName: string) {
    function downloadCSV(csv: string) {
        const csvFile = new Blob([csv], { type: BLOB_PROPERTY_BAG_TYPE });
        const csvURLToDowload = globalThis.URL.createObjectURL(csvFile);
        const tempLink = document.createElement('a');

        tempLink.href = csvURLToDowload;
        tempLink.setAttribute('download', `${reportFileName}${CSV_EXTENSION}`);
        tempLink.click();
    }

    return { convertToCSV, convertToCSVBasedOnModel, downloadCSV };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function convertToCSVBasedOnModel(data: Record<string, any>[], columns: string[]) {
    const { json2csv } = await import('json-2-csv');
    const normalizedData = data.map(item => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const normalized: Record<string, any> = {};
        for (const field of columns) {
            normalized[field] = item[field] ?? '';
        }
        return normalized;
    });

    const csv = json2csv(normalizedData, {
        keys: columns,
        emptyFieldValue: '',
        expandArrayObjects: true,
    });

    return csv;
}
